module.exports = __webpack_public_path__ + "static/media/moraine-10.88b64935.jpg";